import * as roleModalWithRoleEditView from './RoleModalWithMainRoleEditView';

export * from './types';

export const { RoleModalView } = roleModalWithRoleEditView;
